import { render } from "./Atelier.vue?vue&type=template&id=2ce5c958"
import script from "./Atelier.vue?vue&type=script&lang=js"
export * from "./Atelier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__